const OpencloseTypes = {
    FETCH_START:    '[COMMON][OPENCLOSE] FETCH START',
    FETCH_SUCCESS:  '[COMMON][OPENCLOSE] FETCH SUCCESS',
    FETCH_FAILURE:  '[COMMON][OPENCLOSE] FETCH FAILURE'
};

export default OpencloseTypes;